<script>
  import { fly } from "svelte/transition";
  import { portal } from "svelte-portal/src/Portal.svelte";
  import { link } from "../../../../core";
  import List from "./components/List.svelte";

  let isShow = false;

  const closeMenu = () => (isShow = false);
  const toggleMenu = () => (isShow = !isShow);
  const animation = { x: 200, duration: 200 };
</script>

<button name="Navigation" on:click={toggleMenu} aria-label="Navigation">
  <svg class="burger" width="16" height="15" aria-label="navigation">
    <use xlink:href="#burger" />
  </svg>
</button>

{#if isShow}
  <div
    class="mobile-navigation"
    on:click={closeMenu}
    use:portal
    transition:fly={animation}
  >
    <div class="scroll-block">
      <div class="mobile-navigation-header g-centered">
        <a use:link href="/">
          <svg class="logo" width="233" height="28" aria-label="logotype">
            <use xlink:href="#logo-color" />
          </svg>
        </a>

        <button on:click={closeMenu} aria-label="close">
          <svg class="close" width="16" height="16" aria-label="close">
            <use xlink:href="#close" />
          </svg>
        </button>
      </div>

      <div class="mobile-navigation-body" on:click|stopPropagation>
        <List on:click={closeMenu} />
      </div>
    </div>
  </div>
{/if}

<style lang="scss">
  .mobile-navigation {
    @include absolute-wrapper;
    z-index: 100;
    overflow: hidden;
    color: $text-reverse-color;
  }

  .scroll-block {
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    height: 100%;
  }

  .mobile-navigation-header {
    background: $text-reverse-color;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 20px;
    padding-bottom: 20px;

    @include md {
      padding-top: 40px;
      padding-bottom: 25px;
    }
  }

  .logo {
    height: 28px;
    margin-right: 46px;
  }

  .mobile-navigation-body {
    background: $key-color;
    max-height: 100%;
  }
</style>
